
const navMenuItem = [
  {
    url: '/admin/dashboard',
    name: 'Dashboard',
    slug: 'Dashboard',
    icon: 'dashboard',
    i18n: 'Dashboard'
  },

  {
    header: 'Modules',
    icon: 'PackageIcon',
    i18n: 'Modules',
    items: [
      {
        url: '/pages/leads',
        name: 'CRM',
        slug: 'CRM',
        icon: 'contacts',
        i18n: 'CRM'
      },
      {
        url: '/pages/schedule',
        name: 'Schedule',
        slug: 'Schedule',
        icon: 'event',
        i18n: 'Schedule'
      },
      {
        url: '/clients',
        name: 'Students',
        slug: 'Clients',
        icon: 'supervised_user_circle',
        i18n: 'Students'
      },
      {
        url: '/staff',
        slug: 'Staff',
        icon: 'badge',
        i18n: 'Staff'
      },
      {
        url: null,
        name: 'Finance',
        slug: 'Finance',
        icon: 'savings',
        i18n: 'Finance',
        submenu: [
          {
            url: '/pages/finance',
            name: 'Client Payout',
            slug: 'Client Payout',
            icon: 'savings',
            i18n: 'Student Finance'
          },
          {
            url: '/pages/manual-invoice',
            name: 'Manual Invoice',
            slug: 'Manual Invoice',
            icon: 'savings',
            i18n: 'Manual Invoice'
          },
          {
            url: '/staffpayout',
            name: 'Staff Payment',
            slug: 'Staff Payment',
            icon: 'savings',
            i18n: 'StaffPayment'
          }
        ]
      },
      {
        url: '/pages/admission',
        name: 'Admission',
        slug: 'Admission',
        icon: 'contacts',
        i18n: 'Admission'
      },
      {
        url: '/pages/files',
        name: 'Material Files',
        slug: 'Files',
        icon: 'folder_special',
        i18n: 'Files'
      },

      {
        url: '/pages/tasks-project',
        name: 'Tasks & Projects',
        slug: 'Tasks & Projects',
        icon: 'check_box',
        i18n: 'TasksProjects'
      },
      {
        url: null,
        name: 'Attendance',
        slug: 'Attendance',
        icon: 'beenhere',
        i18n: 'Attendance',
        submenu: [
          {
            url: '/pages/attendance',
            name: 'Student Attendance',
            slug: 'Student Attendance',
            icon: 'beenhere',
            i18n: 'Student Attendance'
          },
          {
            url: '/pages/attendance-teacher',
            name: 'Teacher Attendance',
            slug: 'Teacher Attendance',
            icon: 'beenhere',
            i18n: 'Teacher Attendance'
          }
        ]
      }

      // {
      //   url: '/pages/historylog',
      //   name: 'Historylog',
      //   slug: 'Historylog',
      //   icon: 'ClipboardIcon',
      //   i18n: 'Historylog'
      // },

      // {
      //   url: '/pages/settings',
      //   name: 'Settings',
      //   slug: 'Settings',
      //   icon: 'DollarSignIcon',
      //   i18n: 'Settings'
      // }
    ]
  }
  // {
  //   url: '/pages/user-settings',
  //   slug: 'page-user-settings',
  //   name: 'User Settings',
  //   icon: 'SettingsIcon',
  //   i18n: 'UserSettings'
  // },
  // //customvalue setting
  // {
  //   url: '/pages/customvaluesettings',
  //   slug: 'custom-value-settings',
  //   name: 'Custom Settings',
  //   icon: 'SettingsIcon',
  //   i18n: 'CustomSettings'
  // },

]

const navmenuitem21 = [
  {
    url: null,
    name: 'Education',
    icon: 'school',
    i18n: 'Education',
    submenu: [
      {
        url: '/pages/classes',
        name: 'Classes',
        slug: 'Classes',
        icon: 'groups',
        i18n: 'Classes'
      },
      {
        url: '/pages/grade',
        name: 'Grade',
        slug: 'Grade',
        icon: 'star_outline',
        i18n: 'Grade'
      },
      {
        url: '/pages/notes',
        name: 'Notes',
        slug: 'Notes',
        icon: 'description',
        i18n: 'Notes'
      },
      {
        url: '/pages/subjects',
        name: 'Subjects',
        slug: 'Subjects',
        icon: 'bookmarks',
        i18n: 'Subjects'
      },
      {
        url: '/pages/reports',
        name: 'Report',
        slug: 'Reports',
        icon: 'summarize',
        i18n: 'Reports'
      },
      {
        url: '/pages/exam',
        name: 'Exam',
        slug: 'Exam',
        icon: 'rule',
        i18n: 'Tests & Exams'
      },
      {
        url: '/pages/coursework',
        name: 'Homework',
        slug: 'Homework',
        icon: 'bookmarks',
        i18n: 'Coursework'
      },
      // {
      //   url: '/pages/course-builder',
      //   name: 'Course Builder',
      //   slug: 'Course Builder',
      //   icon: 'BookOpenIcon',
      //   i18n: 'Course Builder'
      // },

      {
        url: '/pages/course-builder/course',
        name: 'Courses',
        slug: 'Courses',
        icon: 'collections_bookmark',
        i18n: 'Courses'
      },

      // {
      //   url: '/pages/project',
      //   name: 'Project',
      //   slug: 'Project',
      //   icon: 'BookOpenIcon',
      //   i18n: 'Project'
      // },

      {
        url: '/pages/lessonlist',
        name: 'Lessons',
        slug: 'Lessons',
        icon: 'class',
        i18n: 'Lessons'
      },

      {
        url: '/pages/topiclist',
        name: 'Topics',
        slug: 'Lesson Lisitng',
        icon: 'topic',
        i18n: 'Topics'
      },

      // {
      //   url: '/pages/questions',
      //   name: 'Question Bank',
      //   slug: 'Question Bank',
      //   icon: 'HelpCircleIcon',
      //   i18n: 'Question Bank'
      // },

      // {
      //   url: '/pages/questions-builder',
      //   name: 'Question Bank V2',
      //   slug: 'Question Bank V2',
      //   icon: 'HelpCircleIcon',
      //   i18n: 'Question Builder'
      // },

      // {
      //   url: '/pages/questions-edit',
      //   name: 'Question Edit',
      //   slug: 'Question Edit',
      //   icon: 'HelpCircleIcon',
      //   i18n: 'Question Edit'
      // },
      {
        url: '/pages/questionbanklist',
        name: 'Question Bank',
        slug: 'Question Bank',
        icon: 'comment_bank',
        i18n: 'QuestionBank'
      },
      {
        url: '/pages/certificate-listing',
        name: 'certificate-listing',
        slug: 'Certificates',
        icon: 'verified',
        i18n: 'Certificates'

      }


    ]
  }
]

const navmenuitem12 = [
  {
    url: null,
    name: 'Facilities',
    icon: 'maps_home_work',
    i18n: 'Facilities',
    submenu: [
      {
        url: '/pages/rooms',
        name: 'rooms',
        slug: 'rooms',
        icon: 'meeting_room',
        i18n: 'Rooms'
      },
      {
        url: '/pages/inventory',
        name: 'inventory',
        slug: 'inventory',
        icon: 'inventory',
        i18n: 'Inventory'
      }
    ]
  }
]

const navmenuitem5 = [
  {
    url: null,
    name: 'Communication',
    icon: 'campaign',
    i18n: 'Communication',
    submenu: [
      // {
      //   url: '/pages/email-template',
      //   name: 'Email Template',
      //   slug: 'Email Template',
      //   icon: 'BookIcon',
      //   i18n: 'Email Template'
      // },
      {
        url: '/pages/email',
        name: 'Email',
        slug: 'Email',
        icon: 'email',
        i18n: 'Email'
      },
      // {
      //   url: '/pages/notification-template',
      //   name: 'Notification Template',
      //   slug: 'Notification Template',
      //   icon: 'BookIcon',
      //   i18n: 'Notification Template'
      // },
      {
        url: '/pages/notification',
        name: 'Notification',
        slug: 'Notification',
        icon: 'notifications',
        i18n: 'Notification'
      },
      // {
      //   url: '/pages/sms-template',
      //   name: 'Email Template',
      //   slug: 'Email Template',
      //   icon: 'BookOpenIcon',
      //   i18n: 'SMS Template'
      // },
      {
        url: '/pages/sms',
        name: 'SMS',
        slug: 'SMS',
        icon: 'sms',
        i18n: 'SMS'
      },
      {
        url: '/pages/blogs-post',
        name: 'Blogs and posts',
        slug: 'Blogs and posts',
        icon: 'article',
        i18n: 'Blogsandposts'
      },
      {
        url: '/pages/chat',
        name: 'Chat',
        slug: 'Chat',
        icon: 'question_answer',
        i18n: 'Chat'
      }
    ]
  }
]

const navmenuitem51 = [
  {
    url: null,
    name: 'Analytics ',
    icon: 'analytics',
    i18n: 'Analytics ',
    submenu: [
      {
        url: '/dashboard/analytics',
        name: 'Analytics',
        slug: 'Dashboard',
        icon: 'dashboard',
        i18n: 'Analytics Dashboard'
      },
      {
        url: '/graph',
        slug: 'graph',
        name: 'Graph',
        icon: 'show_chart',
        i18n: 'Graph'
      },
      {
        url: '/pages/summery-settings',
        name: 'Summery Settings',
        icon:'summarize',
        slug: 'summery-settings',
        i18n: 'SummarySettings'
      }
    ]
  }
]

const navmenuitem2 = [

  {
    url: '/pages/settings',
    name: 'General Settings',
    icon:'settings',
    slug: 'settings-management',
    i18n: 'General Settings'
  }
  // url: null,
  // name: 'General Settings',
  // icon: 'settings',
  // i18n: 'GeneralSettings',
  // submenu: [
  // {
  //   url: '/pages/tags',
  //   name: 'Tags',
  //   slug: 'Tags',
  //   icon: 'local_offer',
  //   i18n: 'TagManagement'

  // },
  // {
  //   url: '/pages/customvaluesettings',
  //   slug: 'custom-value-settings',
  //   name: 'Field Management',
  //   icon: 'settings',
  //   i18n: 'FieldManagement'
  // },

  // {
  //   url: '/pages/filtermanagementlist',
  //   slug: 'filter-management-settings',
  //   name: 'Filter Management',
  //   icon: 'settings',
  //   i18n: 'FilterManagementList'
  // },


  // {
  //   url: '/pages/Field-management',
  //   name: 'Field Rearrangement',
  //   icon:'settings',
  //   slug: 'Field Management',
  //   i18n: 'FieldRearrangement'
  // },

  // {
  //   url: '/pages/statusmanagement',
  //   name: 'Status Management',
  //   icon:'settings',
  //   slug: 'status-management',
  //   i18n: 'StatusManagement'
  // },

  // {
  //   url: '/pages/rolemanagement',
  //   name: 'Roles Management',
  //   icon:'settings',
  //   slug: 'role-management',
  //   i18n: 'RoleManagement'
  // },
  // {
  //   url: '/pages/communication/settings',
  //   name: 'Settings',
  //   slug: 'Communication Settings',
  //   icon: 'settings',
  //   i18n: 'Communication'
  // },
  // {
  //   url: '/pages/settings',
  //   name: 'Setting',
  //   icon:'settings',
  //   slug: 'settings-management',
  //   i18n: 'Settings'
  // }
]


const navmenuitem3 = [...navMenuItem, ...navmenuitem21, ...navmenuitem51, ...navmenuitem12, ...navmenuitem5, ...navmenuitem2]

export default navmenuitem3

